import React from "react"
import { ExternalLink } from "components"
import AllisonGraceWilliams from "images/panelists/allison-grace-williams.jpg"
import AriMelenciano from "images/panelists/ari-melenciano.jpg"
import BridgetteWallace from "images/panelists/bridgette-wallace.jpg"
import BillyAlmon from "images/panelists/billy-almon.jpg"
import CharlesWallaceThomas from "images/panelists/charles-wallace-thomas.jpg"
import AdolphusOpara from "images/panelists/adolphus-opara.jpg"
import DeniseShanteBrown from "images/panelists/denise-shante-brown.jpg"
import DeNichols from "images/panelists/denichols.jpg"
import DianeAllenJones from "images/panelists/diane-allen-jones.jpg"
import FeleciaDavis from "images/panelists/felecia-davis.jpg"
import JeromHarris from "images/panelists/jerome-harris.jpg"
import KennethBailey from "images/panelists/kenneth-bailey.jpg"
import MalcolmDavis from "images/panelists/malcolm-davis.jpg"
import NiaEvans from "images/panelists/nia-evans.jpg"
import ToniLGriffin from "images/panelists/toni-l-griffin.jpg"

export default {
  label: "Speakers",
  title: "Speakers",
  body: (
    <div>
      <p>
        Extending the dialogue of black futurism through politics, design and
        justice.
      </p>
    </div>
  ),
  speakers: [
    {
      type: "Keynote",
      name: "Pierce Freelon",
      bio: (
        <>
          <p>
            Pierce Freelon is a professor, director, musician, Emmy-Award
            winning producer, and a millennial politician who is running for
            North Carolina State Senate.
          </p>
          <p>
            He is the founder of Blackspace, a digital maker space in Durham
            where young people learn about music, film and coding. He is the
            writer, composer and co-director of an animated series called
            History of White People in America, which premiered at the Tribeca
            Film Festival back-to-back in 2018 and 2019. He is a co-founder of
            Beat Making Lab, a PBS web-series, which won Best Video Essay for
            its episode Heartbeats of Fiji at the 2015 Daytime Emmy Awards.
          </p>
          <p>
            Born and raised in Durham, Pierce ran for Mayor in 2017 on a
            platform of Community, Growth, Youth and Love. He is currently a
            candidate for North Carolina State Senate.
          </p>
          <p>
            Pierce earned a BA in African and African American Studies at UNC
            Chapel Hill and an MA in Pan African Studies at Syracuse University.
            He has taught music, political science, and African American studies
            at both UNC Chapel Hill and North Carolina Central University.
          </p>
          <p>
            Pierce lives in Durham with his wife of 11 years and their two
            children.
          </p>
        </>
      ),
      img: {
        alt: "Pierce Freelon",
      },
    },
    {
      type: "Keynote",
      name: "Deanna Van Buren",
      bio: (
        <>
          <p>
            Deanna Van Buren is the design director and co-founder of{" "}
            <ExternalLink url="http://designingjustice.org/">
              Designing Justice + Designing Spaces
            </ExternalLink>{" "}
            (DJDS), an architecture and real estate development non-profit
            working to end mass incarceration by building infrastructure that
            attacks its root causes: poverty, racism, unequal access to
            resources, and the criminal justice system itself.
          </p>
          <p>
            Unlike the traditional adversarial and punitive architecture of
            justice—courthouses, prisons and jails—the Oakland-based DJDS
            creates spaces and buildings for restorative justice, rehabilitation
            and community building.
          </p>
          <p>
            Van Buren’s most notable projects include:{" "}
            <ExternalLink url="http://restoreoakland.org/">
              Restore Oakland
            </ExternalLink>
            , a multi-use hub for restorative justice and workforce development
            in East Oakland, created in collaboration with the Ella Baker Center
            for Human Rights and Restaurant Opportunities Centers United (ROC
            United); the{" "}
            <ExternalLink url="http://designingjustice.org/near-westside-peacemaking-center/">
              Near Westside Peacemaking Center
            </ExternalLink>{" "}
            in Syracuse, New York;{" "}
            <ExternalLink url="https://www.popupvillage.org/">
              Pop-Up Village
            </ExternalLink>
            , a mobile event that brings a constellation of resources to
            under-resourced communities; and{" "}
            <ExternalLink url="http://designingjustice.org/womens-refuge-trailer/">
              The Women’s Mobile Refuge Center
            </ExternalLink>
            , a mobile overnight space for women who have recently been released
            from incarceration.
          </p>
          <p>
            A pioneering activist, Van Buren has been recognized internationally
            for her leadership in using architecture, design, and real estate
            innovations to address the social inequities behind the mass
            incarceration crisis. Her 2017{" "}
            <ExternalLink url="https://www.ted.com/talks/deanna_van_buren_what_a_world_without_prisons_could_look_like">
              TEDWomen
            </ExternalLink>{" "}
            talk on what a world without prisons could look like has been viewed
            more than one million times, and she is the only architect to have
            been awarded the Rauschenberg Artist as Activist fellowship.
          </p>
          <p>
            Van Buren is also the recipient of UC Berkeley’s prestigious{" "}
            <ExternalLink url="https://rupp.ced.berkeley.edu/">
              2018 Berkeley-Rupp Architecture Prize and Professorship
            </ExternalLink>
            , which awards $100,000 biannually to a design practitioner who has
            made a significant contribution to advancing gender equity in
            architecture, and whose work emphasizes a commitment to
            sustainability and community.
          </p>
          <p>
            Van Buren received her BS in architecture from the University of
            Virginia and her MA from Columbia University. She is an alumnus of
            the Loeb Fellowship at Harvard’s Graduate School of Design.
          </p>
        </>
      ),
      img: {
        alt: "Deanna Van Buren",
      },
    },
  ],
  panelists: [
    {
      type: "panel",
      name: "Felecia Davis",
      bio: (
        <p>
          Trained as both an engineer and as an architect, Felecia Davis is
          known for her rigorous investigation of Architextiles. Or rather,
          using digital soft fabrication and computation, Davis studies the
          intersection of architecture and textile production in the pursuit of
          constructing inhabitable space.
        </p>
      ),
      img: {
        url: FeleciaDavis,
      },
      url: "https://aadn.gsd.harvard.edu/people/felecia-davis/",
    },
    {
      type: "panel",
      name: "Allison Grace Williams",
      bio: (
        <p>
          As Principal of her own firm, Allison Grace Williams’s execution of
          commercial, civic, and corporate projects allows her to lead by
          example; Williams’s designs seamlessly integrate urban context,
          history, climate, and cultural demands with her personal and
          professional design agendas.
        </p>
      ),
      img: {
        url: AllisonGraceWilliams,
      },
      url: "https://aadn.gsd.harvard.edu/people/allison-grace-williams/",
    },
    {
      type: "panel",
      name: "Diane Allen Jones",
      bio: (
        <p>
          Landscape architect, author, and program director of landscape
          architecture at the University of Texas at Arlington, Diane Jones
          Allen creates work committed to environmental justice, sustainability,
          and the cultural significance of landscape while advocating for the
          transformative potential of design.
        </p>
      ),
      img: {
        url: DianeAllenJones,
      },
      url: "https://aadn.gsd.harvard.edu/people/diane-jones-allen/",
    },
    {
      type: "panel",
      name: "Toni L. Griffin",
      bio: (
        <p>
          Toni L. Griffin is the founder of Urban Planning and Design for the
          American City, based in New York. Through the practice, Toni served as
          Project Director the long range planning initiative of the Detroit
          Work Project, and in 2013 completed and released Detroit Future City,
          a comprehensive citywide framework plan for urban transformation.
        </p>
      ),
      img: {
        url: ToniLGriffin,
      },
      url: "https://www.gsd.harvard.edu/person/toni-l-griffin/",
    },
    {
      type: "panel",
      name: "Kenneth Bailey",
      bio: (
        <p>
          Co-founder of the Design Studio for Social Intervention (ds4si). His
          interests focus on the research and development of design tools for
          marginalized communities to address complex social issues. With over
          three decades of experience in community practice, Bailey brings a
          unique perspective on the ethics of design in relation to community
          engagement, the arts and cultural action.
        </p>
      ),
      img: {
        url: KennethBailey,
      },
      url: "https://www.bennington.edu/academics/faculty/kenneth-bailey",
    },
    {
      type: "panel",
      name: "Malcolm Davis",
      bio: (
        <p>
          Raised in Norfolk and Richmond, Virginia by parents who vastly
          expanded his understanding of the world through travel. This early
          exposure to people of different cultures led to his interest in
          cultivating genuine relationships and discovering the inherent
          differences and similarities that define people and communities.
        </p>
      ),
      img: {
        url: MalcolmDavis,
      },
      url: "https://perkinswill.com/person/malcolm-davis/",
    },
    {
      type: "panel",
      name: "Ari Melenciano",
      bio: (
        <p>
          A Brooklyn-based interdisciplinary artist, designer, creative
          technologist, and researcher who is passionate about exploring the
          relationships between various forms of design and the human
          experience.
        </p>
      ),
      img: {
        url: AriMelenciano,
      },
      url: "http://www.ariciano.com/about",
    },
    {
      type: "panel",
      name: "Bridgette Wallace",
      bio: (
        <p>
          An out-of-the-box thinker who pushes hard for equity and inclusion for
          those that are undervalued and overlooked. Her goal is inclusion, by
          creating and supporting additional pipelines that enhances the city's
          innovation mix by focusing on women, housing, technology, and
          entrepreneurship.
        </p>
      ),
      img: {
        url: BridgetteWallace,
      },
      url: "https://www.thegcodehouse.com/",
    },
    {
      type: "panel",
      name: "Jerome Harris",
      bio: (
        <p>
          Jerome Harris is a graphic designer originally from New Haven,
          Connecticut and currently based in Brooklyn, New York. Harris holds an
          MFA in Graphic Design from Yale University and a BA from Temple
          University. Harris is the Design Director of Housing Works, a
          non-profit organization fighting the HIV/AIDS and homelessness crisis
          in New York City.
        </p>
      ),
      img: {
        url: JeromHarris,
      },
    },
    {
      type: "panel",
      name: "Billy Almon",
      bio: (
        <p>
          Billy Almon is a designer and storyteller who highlights the
          connection between nature, technology, and design. Over the last 3
          years Billy has been traveling around the world exploring how
          biological strategies are being used to inspire solutions to human
          challenges through the process called Biomimicry.
        </p>
      ),
      img: {
        url: BillyAlmon,
      },
    },
    {
      type: "panel",
      name: "Denise Shanté Brown",
      bio: (
        <p>
          Denise Shanté Brown is a holistic design strategist, mental health
          advocate, creative healer and feminist entrepreneur co-designing
          possibilities for health and healing in Baltimore.
        </p>
      ),
      img: {
        url: DeniseShanteBrown,
      },
      url: "https://www.deniseshantebrown.com/",
    },
    {
      type: "panel",
      name: "Nia Evans",
      bio: (
        <p>
          Nia K. Evans is the Director of the Boston Ujima Project. Her
          educational background is in the areas of labor relations, education
          leadership, and policy. Her advocacy includes a focus on eliminating
          barriers between analysts and people with lived experiences as well as
          increasing acknowledgement of the value of diverse types of expertise
          in policy.
        </p>
      ),
      img: {
        url: NiaEvans,
      },
    },
    {
      type: "panel",
      name: "Charles Wallace-Thomas IV",
      bio: (
        <p>
          Charles is a third-year student at Northeastern University studying
          Economics and Mathematics with a minor in Psychology. At Northeastern,
          Charles is the Director of Northeastern Students Against Institutional
          Discrimination (SAID), a coalition of student activists confronting
          institutional marginalization by empowering students to become better
          organizers through political education and direct action.
        </p>
      ),
      img: {
        url: CharlesWallaceThomas,
      },
    },
    {
      type: "panel",
      name: "Adolphus Opara",
      bio: (
        <p>
          Adolphus Opara (Lagos, Nigeria). Opara’s work is induced by encounters
          with people and their daily effort to exist amidst obstacles that
          define and situate their individual locality. Opara uses visual
          storytelling to better understand as well as to show his connection to
          the issues that confronts him daily. Opara’s work has been widely
          exhibited at many international venues including the Tate Modern in
          London.
        </p>
      ),
      img: {
        url: AdolphusOpara,
      },
    },
    {
      type: "panel",
      name: "Moderator: De Andrea Nichols",
      bio: (
        <p>
          Through a multidisciplinary creative practice, De Nichols mobilizes
          global changemakers to activate ideas that address civic and social
          challenges within their communities. Based in St. Louis, MO, De
          Nichols serves as the Social Impact Design Principal of Civic
          Creatives, a design strategy agency that develops interactive
          experiences, tools, and initiatives to help communities engage issues
          of civic disengagement, youth development, social inclusion, food
          access and security, and arts & cultural policy.
        </p>
      ),
      img: {
        url: DeNichols,
      },
      url: "https://www.denichols.co/about",
    },
  ],
}
